import { createApiCall } from 'lib/base';

export interface AccessToken {
  access_token: string;
  expires_at: string;
  email: string;
}

/** Issues a personal admin token for the signed-in staff member. */
export const createAccessTokenApiCall = createApiCall<{ days: number }>(
  'INVESTCORE/CREATE_ACCESS_TOKEN_API',
  ({ days }) => ({
    endpoint: '/api/admin/auth/tokens',
    method: 'POST',
    body: { days },
  })
);
